import { styled } from '@mui/material/styles';

export const PAGE_TITLE_HEIGHT = 44;

export const Container = styled('div')({
    height: PAGE_TITLE_HEIGHT,
    paddingBottom: 16,
    flex: 'none',
    minWidth: 0,
    '@media (max-width: 1024px)': {
        display: 'none',
    },
    '@media print': {
        display: 'none',
    },
});
